import jwt_decode from 'jwt-decode';

/**
 * The automated QA harness's own logins — QA Admin / Mentor / Learner / Empty
 * (`dosen-qa-admin@yopmail.com` …) and the per-run ephemeral ones
 * (`dosen-qa-<runId>-<role>@yopmail.com`). Mirrors the BE's QA_HARNESS_EMAIL_RE.
 *
 * Deliberately narrower than "any yopmail address": Dosen staff build real
 * customer programs from yopmail logins, and their activity must still count.
 */
export const QA_HARNESS_EMAIL_RE = /^dosen-qa-[^@]*@yopmail\./i;

export function isQaHarnessEmail(email: unknown): boolean {
  return QA_HARNESS_EMAIL_RE.test(String(email || '').trim());
}

let cachedIdToken: string | null = null;
let cachedIsQaHarness = false;

/**
 * True when the logged-in session belongs to a QA harness account. Reads the
 * id token straight from localStorage (no Redux import, so analytics utilities
 * can use it without an import cycle) and checks both email claims. Cached per
 * token, since it runs on every tracked event.
 */
export function isQaHarnessSession(): boolean {
  let idToken = '';
  try {
    const raw = localStorage.getItem('tokens');
    idToken = raw ? JSON.parse(raw)?.id_token || '' : '';
  } catch {
    return false;
  }
  if (!idToken) return false;
  if (idToken === cachedIdToken) return cachedIsQaHarness;
  let result = false;
  try {
    const claims: any = jwt_decode(idToken);
    result = isQaHarnessEmail(claims?.email) || isQaHarnessEmail(claims?.user_metadata?.email);
  } catch {
    result = false;
  }
  cachedIdToken = idToken;
  cachedIsQaHarness = result;
  return result;
}
